/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfBusinessAccount } from "../models/AjaxResponseOfBusinessAccount";
import type { AjaxResponseOfListOfAdSetLookupDto } from "../models/AjaxResponseOfListOfAdSetLookupDto";
import type { AjaxResponseOfListOfTeamLookupDto } from "../models/AjaxResponseOfListOfTeamLookupDto";
import type { AjaxResponseOfMetaAdsetsDto } from "../models/AjaxResponseOfMetaAdsetsDto";
import type { AjaxResponseOfPagedMetaAdsetsResultDto } from "../models/AjaxResponseOfPagedMetaAdsetsResultDto";
import type { AjaxResponseOfString } from "../models/AjaxResponseOfString";
import type { CreateAdDto } from "../models/CreateAdDto";
import type { CreateMetaAdsetsDto } from "../models/CreateMetaAdsetsDto";
import type { UpdateAdStatusDto } from "../models/UpdateAdStatusDto";
import type { UpdateMetaAdsetsDto } from "../models/UpdateMetaAdsetsDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class MetaAdsetsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfPagedMetaAdsetsResultDto Success
   * @throws ApiError
   */
  public getAllAdSets({
    filter,
    teamId,
    isActive,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    teamId?: number;
    isActive?: boolean;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedMetaAdsetsResultDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/staff/meta-adsets",
      query: {
        filter: filter,
        teamId: teamId,
        isActive: isActive,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns AjaxResponseOfMetaAdsetsDto Success
   * @throws ApiError
   */
  public createAdSet({
    requestBody,
  }: {
    requestBody?: CreateMetaAdsetsDto;
  }): CancelablePromise<AjaxResponseOfMetaAdsetsDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/staff/meta-adsets",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfMetaAdsetsDto Success
   * @throws ApiError
   */
  public updateAdSet({
    requestBody,
  }: {
    requestBody?: UpdateMetaAdsetsDto;
  }): CancelablePromise<AjaxResponseOfMetaAdsetsDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/staff/meta-adsets",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfAdSetLookupDto Success
   * @throws ApiError
   */
  public getAdSetsForLookup(): CancelablePromise<AjaxResponseOfListOfAdSetLookupDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/staff/meta-adsets/adsets-lookup",
    });
  }
  /**
   * @returns AjaxResponseOfBusinessAccount Success
   * @throws ApiError
   */
  public getBusinessAccountByTeam({
    teamId,
  }: {
    teamId: number;
  }): CancelablePromise<AjaxResponseOfBusinessAccount> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/staff/meta-adsets/business-account/{teamId}",
      path: {
        teamId: teamId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public downAd({
    requestBody,
  }: {
    requestBody?: UpdateAdStatusDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/staff/meta-adsets/down-ad",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfTeamLookupDto Success
   * @throws ApiError
   */
  public getTeamsForLookup(): CancelablePromise<AjaxResponseOfListOfTeamLookupDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/staff/meta-adsets/teams-lookup",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public upNewAd({
    requestBody,
  }: {
    requestBody?: CreateAdDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/staff/meta-adsets/up-ad",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfString Success
   * @throws ApiError
   */
  public getVehicleWithShortCodeMeta({
    providerPublishId,
    shortcode,
  }: {
    providerPublishId?: string;
    shortcode?: string;
  }): CancelablePromise<AjaxResponseOfString> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/staff/meta-adsets/vehicle-info",
      query: {
        providerPublishId: providerPublishId,
        shortcode: shortcode,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteAdSet({ id }: { id: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/staff/meta-adsets/{id}",
      path: {
        id: id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfMetaAdsetsDto Success
   * @throws ApiError
   */
  public getAdSet({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfMetaAdsetsDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/staff/meta-adsets/{id}",
      path: {
        id: id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
}
